<template>
  <layout-admin-dashboard-view
    :show-toolbar="false"
    :back-route="{ name: 'admin' }">
    <template #title>
      <span>{{ translateTitleCase("ecommerce.vendors.displayTitle") }}</span>
    </template>

    <template #default>
      <custom-crud-list v-bind="listConfiguration">
        <template v-slot:cell-logoImageUrl="{item}">
          <img :src="item.logoImageUrl" style="max-height:50px;width:auto;max-width: 200px;" alt="">
        </template>
        <template v-slot:cell-state="{item}">
          <div>
            <icon theme="success" icon="check" v-if="item.state === 1"></icon>
            <icon theme="error" icon="x" v-if="item.state !== 1"></icon>
          </div>
        </template>
        <template v-slot:cell-featured="{item}">
          <div>
            <icon theme="success" icon="check" v-if="item.featured === true"></icon>
            <icon theme="error" icon="x" v-if="item.featured !== true"></icon>
          </div>
        </template>
        <template v-slot:cell-user="{item}">
          <span>
            <span v-if="item.User">{{item.User?.fullName}} - <br>{{item.User?.email}}</span>
             <span v-else>-</span>
          </span>
        </template>

      </custom-crud-list>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import CustomCrudList from "@/client/components/crud/customV1/List.vue";
import asyncComponentFactory from "@/client/extensions/modules/asyncComponentFactory";
export default {
  components: {
    CustomCrudList,
    VersionManager: asyncComponentFactory('components/crud/customV1/VersionManager.vue',true),
  },
  layout: "adminDashboard",

  middleware: {
    requireSuperAdmin: {},
  },
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "admin.vendors.pageTitle",
  data: function () {
    return {
      listConfiguration: {
        subject: "vendor",
        listSrc: "ecommerce/vendor",
        showIdField: true, // bool default true
        sortable: true, //bool, default false
        publishable: true, //bool, default false
        enableMassActions: true,
        editRoutePrefix: "admin-",
        createRoutePrefix: "admin-",
        deleteRoutePrefix: "ecommerce/",
        additionalGetListData: {
        //  simplified: false,
        //  translate: false,
          with: ['user']
        },
        fields: {
          // these are the table columns
          name: {
            itemKey: "name",
            label: "ecommerce.vendor.fields.name",
            filterable: true, // boolean, or object
            orderable: true,
          },
          state: {
            itemKey: "state",
            label: "entity.crud.state",
            filterable: {
              name: 'state',
              type: "select2",
              placeholder: "entity.crud.state",
              list: [
                {value: undefined, label: "entity.generic.states.all"},
                {value: 1, label: "entity.generic.states.1"},
                {value: 0, label: "entity.generic.states.0"},
              ]
            }, // boolean, or object
            quickEdit: {
              type: "binaryInteger",
            },
            orderable: true,
          },
          featured: {
            itemKey: "featured",
            label: "ecommerce.vendor.fields.featured",
            filterable: {
              name: 'featured',
              type: "select2",
              placeholder: "ecommerce.vendor.fields.featuredPlaceholder",
              list: [
                {value: undefined, label: "ecommerce.vendor.fields.featuredNull"},
                {value: true, label: "ecommerce.vendor.fields.featuredTrue"},
                {value: false, label: "ecommerce.vendor.fields.featuredFalse"},
              ]
            }, // boolean, or object
            orderable: true,
          },
          logoImageUrl: {
            itemKey: "logoImageUrl",
            label: "ecommerce.vendor.fields.logoImageUrl",
          },
          user: {
            itemKey: "user",
            label: "ecommerce.vendor.fields.user",
            filterable: false, // boolean, or object
            orderable: false,
          },
        },
        actions: {
          show: false,
          edit: true,
          delete: true,
          custom: {
            loginAsUser: {
              //tooltip
              text: "ecommerce.vendor.admin.loginAsUser.label",
              tooltip: { content: "ecommerce.vendor.admin.loginAsUser.label" },
              icon: "arrow-login-inline-end",
              theme: "inverse",
              //text
              handler: async ({ item }) => {
                if (!item || !item?.User?.id) {
                  this.$s.ui.notification(
                    "ecommerce.vendor.admin.loginAsUser.errorNotification",
                    "error"
                  );
                  return false;
                }

                let res = await this.asyncOps.asyncCall(
                  `token/refresh/user/${item?.User?.id}`,
                  {},
                  { method: "post" }
                );

                if (res.hasError) {
                  this.$s.ui.notification("core.genericError", "error");
                  return false;
                }

                this.$store.commit("user/setToken", res.data.jwt);
                this.$store.commit(
                  "user/setRefreshToken",
                  res.data.refreshToken
                );

                this.$store.commit(
                  "user/setRefreshTokenExpires",
                  res.data.refreshTokenExpires
                );

                let loginResult = await this.$store.dispatch(
                  "user/updateUserProfile"
                );

                if (loginResult === false) {
                  this.$saffron.ui.notification(
                    this.safeTranslate(
                      "user.admin.list.actions.loginAsUser.loginFailErrorAndLostAccess"
                    ),
                    "danger"
                  );
                  this.$store.commit("user/invalidateAuth");
                  this.$store.commit("user/clearProfile");
                  this.$router.push("/");
                  return false;
                }

                this.$s.ui.notification(
                  "user.admin.list.actions.loginAsUser.successNotification",
                  "success"
                );
                this.$router.push("/");
              },
            },
          }
        },
      },
      asyncData: {},
    };
  },
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
